import { PollOverview } from 'api/api.types';
import ApiContext from 'api/ApiContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

const useElectionTeaserTitle = (electionItem: PollOverview) => {
  const { t } = useTranslation('wap');
  const { language } = useContext(ApiContext);

  const titleTopic =
    electionItem.short_title?.[language] || electionItem.title?.[language];

  const isLocalElection =
    electionItem.scope === 'district' || electionItem.scope === 'subregional';
  let electionDomain = '';
  if (electionItem.short_title && electionItem.domain_name?.[language]) {
    switch (electionItem?.domain_type) {
      case 'subregion':
      case 'district':
        electionDomain = t(electionItem?.domain_type, {
          region: electionItem.domain_name?.[language],
        });
        break;
      default:
        electionDomain = isLocalElection ? electionItem.domain_name?.[language] : '';
    }
  }

  return electionDomain ? `${electionDomain}:  ${titleTopic}` : titleTopic;
};

export default useElectionTeaserTitle;
